export default __webpack_public_path__ + "static/media/privilegio-plus.e0585e0c.jpg";